import React from 'react';
import { Text, View, Linking, Pressable } from 'react-native';
import { Icon } from 'LocalGluons';
import { Device } from 'DeviceUtils';
import { t } from 'Locale';
import Checkbox from '../NativeConsentCheckBox';
import itemStyle from './NativeConsentItem.jss';

interface NativeConsentItemProps {
    approval: boolean;
    consentTitle: string;
    consentDescription: string;
    link: string;
    onCheckboxClick: () => void;
}

const NativeConsentItem = ({
    approval,
    consentTitle,
    consentDescription,
    link,
    onCheckboxClick
}: NativeConsentItemProps): JSX.Element => (
    <View style={itemStyle.container}>
        <Pressable
            style={[itemStyle.clickableRow, itemStyle.rightOffset]}
            onPress={onCheckboxClick}
        >
            <Text style={itemStyle.title}>{consentTitle}</Text>
            <Checkbox
                approval={approval}
                borderColor="#FFFFFF"
                borderRadius={6}
                size={24}
                backgroundColor="rgba(252, 252, 252, 0.15)"
            />
        </Pressable>

        <Text
            style={[
                itemStyle.desc,
                Device.isTabletOrWeb
                    ? itemStyle.tabletWebDescPadding
                    : itemStyle.phoneDescPadding
            ]}
        >
            {consentDescription}
        </Text>

        <Pressable
            onPress={() => {
                if (Device.isPhone || Device.isTablet) {
                    return Linking.openURL(link);
                }
                return window.open(link, '_blank');
            }}
        >
            <View style={itemStyle.blueButtonContainer}>
                <Text style={itemStyle.buttonText}>{t('CONSENTS.SETTINGS_READ_MORE_BTN_MOBILES')}</Text>
                <View style={{ width: 8 }} />
                <Icon style={itemStyle.blueButtonIcon} name="blue_chevron_right" />
            </View>
        </Pressable>
    </View>
);

export default NativeConsentItem;
